import React from 'react';
import { Typography, Button, Tooltip } from 'antd';
import { ChevronRight } from 'lucide-react';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/layout/app-card';

const { Text } = Typography;

interface QuickAccessItem {
  key: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

interface QuickAccessProps {
  items: QuickAccessItem[];
}

export const QuickAccess: React.FC<QuickAccessProps> = ({ items }) => {
  const { fontSize, spacing } = useResponsiveSizes();

  return (
    <div style={{ flex: 1 }}>
      <Typography.Title
        style={{
          textAlign: 'left',
          fontSize: fontSize.xl,
          fontWeight: 500,
          color: tokens.colors.primary.neutral[1010]
        }}
      >
        Accesos rápidos
      </Typography.Title>
      <AppCard>
        {items.map((item, index) => (
          <Button
            key={item.key}
            type='text'
            onClick={item.onClick}
            disabled={item.disabled}
            style={{
              width: '100%',
              height: 'auto',
              padding: `${spacing.sm}px`,
              marginBottom: index < items.length - 1 ? spacing.xs : 0,
              textAlign: 'left',
              background: 'transparent',
              paddingLeft: 16,
              borderRadius: '8px',
              borderLeft: '3px solid transparent',
              cursor: item.disabled ? 'not-allowed' : 'pointer',
              opacity: item.disabled ? 0.6 : 1
            }}
            onMouseEnter={e => {
              if (!item.disabled) {
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                e.currentTarget.style.borderColor = 'rgba(102, 126, 234, 0.2)';
              }
            }}
            onMouseLeave={e => {
              if (!item.disabled) {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = 'transparent';
              }
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: spacing.md, flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    background: 'rgba(102, 126, 234, 0.1)',
                    width: spacing.xxl,
                    height: spacing.xxl,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 6,
                    flexShrink: 0
                  }}
                >
                  {item.icon}
                </div>

                <Tooltip title={item.disabled ? 'Próximamente' : ''} placement='right'>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <Text
                      style={{
                        fontSize: fontSize.xlg,
                        display: 'block',
                        fontWeight: 500,
                        color: tokens.colors.primary.neutral[1010]
                      }}
                    >
                      {item.title}
                    </Text>
                    <Text
                      type='secondary'
                      style={{ fontSize: fontSize.base, display: 'block', color: tokens.colors.primary.neutral[550] }}
                    >
                      {item.description}
                    </Text>
                  </div>
                </Tooltip>
              </div>
              {!item.disabled && <ChevronRight style={{ color: '#999', flexShrink: 0 }} />}
            </div>
          </Button>
        ))}
      </AppCard>
    </div>
  );
};

export default QuickAccess;
